import Vue from 'vue'
import Router from 'vue-router'

const CompanyContactHome = () =>
  import(
    /* webpackChunkName: "chunk-company-home" */ '@/pages/CompanyContact/CompanyContactHome.vue'
  )
const CompanyContactEdit = () =>
  import(
    /* webpackChunkName: "chunk-company-edit" */ '@/pages/CompanyContact/CompanyContactEdit.vue'
  )
const TenantHome = () =>
  import(/* webpackChunkName: "chunk-tenant-home" */ '@/pages/Central/Tenants/TenantsHome.vue')
const TenantEdit = () =>
  import(/* webpackChunkName: "chunk-tenant-edit" */ '@/pages/Central/Tenants/TenantEdit.vue')

const Login = () => import(/* webpackChunkName: "chunk-login" */ '@/pages/Login/Login.vue')

// Company
const CompanyHome = () =>
  import(/* webpackChunkName: "chunk-companies" */ '@/pages/Company/CompanyHome.vue')
const CompanyEdit = () =>
  import(/* webpackChunkName: "chunk-companies-edit" */ '@/pages/Company/CompanyEdit.vue')
const CompanyDetails = () =>
  import(/* webpackChunkName: "chunk-company-details" */ '@/pages/Company/CompanyDetails.vue')
// Account
const UserAccount = () =>
  import(/* webpackChunkName: "chunk-account" */ '@/pages/User/UserAccount.vue')

// Users
const UserHome = () => import(/* webpackChunkName: "chunk-users" */ '@/pages/User/UserHome.vue')
const UserEdit = () =>
  import(/* webpackChunkName: "chunk-users-edit" */ '@/pages/User/UserEdit.vue')

// Profile
const ProfileHome = () =>
  import(/* webpackChunkName: "chunk-profile" */ '@/pages/Profile/ProfileHome.vue')
const ProfileEdit = () =>
  import(/* webpackChunkName: "chunk-profile-edit" */ '@/pages/Profile/ProfileEdit.vue')
const Layout = () => import('@/components/Layout/Layout.vue')

const SystemParameterHome = () =>
  import(
    /* webpackChunkName: "chunk-system-params-home" */ '@/pages/SystemParams/SystemParamsHome.vue'
  )

const FaqHome = () => import(/* webpackChunkName: "chunk-faq-home" */ '@/pages/FAQ/FaqHome.vue')
const FaqEdit = () => import(/* webpackChunkName: "chunk-faq-edit" */ '@/pages/FAQ/FaqEdit.vue')

// Audit
const AuditHome = () => import(/* webpackChunkName: "chunk-audit" */ '@/pages/Audit/AuditHome.vue')

// #### Place the central routes

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      secure: false,
    },
  },
  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: 'companies',
        name: 'Companies',
        component: CompanyHome,
        meta: {
          secure: true,
          model: 'company',
          action: 'view',
          index: 'companies',
        },
      },
      {
        path: 'company/:id?',
        name: 'Company',
        component: CompanyEdit,
        props: true,
        meta: {
          secure: true,
          model: 'company',
          action: 'edit',
          index: 'companies',
        },
      },
      {
        path: 'company/:id/details',
        name: 'company-details',
        component: CompanyDetails,
        meta: {
          secure: true,
          model: 'company',
          action: 'view',
          index: 'companies',
        },
      },
      {
        path: 'company-contacts',
        name: 'company-contacts',
        component: CompanyContactHome,
        meta: {
          secure: true,
          model: 'opportunity',
          action: 'view',
          index: 'company-contacts',
        },
      },
      {
        path: 'company-contact/:id?',
        name: 'company-contact',
        component: CompanyContactEdit,
        meta: {
          secure: true,
          model: 'opportunity',
          action: 'view',
          index: 'company-contacts',
        },
      },
      {
        path: 'account/:oauth?',
        name: 'Account',
        component: UserAccount,
        props: true,
        meta: {
          secure: true,
          index: 'account',
        },
      },
      {
        path: 'users',
        name: 'Users',
        component: UserHome,
        meta: {
          secure: true,
          model: 'user',
          action: 'view',
          index: 'users',
        },
      },
      {
        path: 'user/:id?',
        name: 'User',
        component: UserEdit,
        props: true,
        meta: {
          secure: true,
          model: 'user',
          action: 'edit',
          index: 'users',
        },
      },

      {
        path: 'profiles',
        name: 'Profiles',
        component: ProfileHome,
        meta: {
          secure: true,
          model: 'profile',
          action: 'view',
          index: 'profiles',
        },
      },
      {
        path: 'profile/:id?',
        name: 'Profile',
        component: ProfileEdit,
        props: true,
        meta: {
          secure: true,
          model: 'profile',
          action: 'edit',
          index: 'profiles',
        },
      },
      {
        path: 'tenants',
        name: 'tenants',
        component: TenantHome,
        meta: {
          secure: true,
          model: 'tenant',
          action: 'edit',
          index: 'tenants',
        },
      },
      {
        path: 'tenant/:id?',
        name: 'tenant',
        component: TenantEdit,
        meta: {
          secure: true,
          model: 'tenant',
          action: 'view',
          index: 'tenants',
        },
      },
      {
        path: 'system-parameters',
        name: 'system-parameters',
        component: SystemParameterHome,
        meta: {
          secure: true,
          model: 'system_config',
          action: 'view',
          index: 'system-parameters',
        },
      },
      {
        path: 'faq-home',
        name: 'faq-home',
        props: true,
        component: FaqHome,
        meta: {
          secure: true,
          model: 'faq',
          action: 'edit',
          index: 'faq',
        },
      },
      {
        path: 'faq/:id?',
        name: 'faq',
        props: true,
        component: FaqEdit,
        meta: {
          secure: true,
          model: 'faq',
          action: 'edit',
          index: 'faq',
        },
      },
      {
        path: 'audit',
        name: 'Audit',
        component: AuditHome,
        meta: {
          secure: true,
          model: 'audit',
          action: 'view',
          index: 'adunits',
        },
      },
    ],
  },
]
